var _desc, _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "807px",
    height: "900px",
    viewBox: "0 0 807 900",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Group") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "iOS-7-Icon-Grid",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    transform: "translate(-108.000000, -62.000000)",
    strokeLinecap: "round"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(123.000000, 77.000000)",
    stroke: "#FA8872",
    strokeWidth: 30
  }, /*#__PURE__*/React.createElement("g", {
    id: "Page-1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M512.922006,58.5620409 L431.235572,11.4412027 C404.790164,-3.81373424 372.20835,-3.81373424 345.762941,11.4412027 L42.7363156,186.242492 C16.2909069,201.497429 0,229.690322 0,260.200196 L0,609.801289 C0,640.311163 16.2909069,668.502571 42.7363156,683.757508 L345.762941,858.558797 C372.20835,873.813734 404.790164,873.813734 431.235572,858.558797 L734.260711,683.757508 C760.707607,668.502571 777,640.311163 777,609.801289 L776.036727,499.052615",
    id: "Stroke-1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M763,215 L529.228354,349.172485 C521.528509,353.599137 515.32313,360.222754 511.410752,368.198463 L412.966341,568.781144 C410.579657,573.643619 407.32752,578.03011 403.370531,581.727912 L355.519368,626.433233 C351.305123,630.370514 347.871569,635.070857 345.403098,640.28437 C342.504875,646.406716 341,653.097268 341,659.871117 L341,740.041716 C341,744.617114 345.945864,747.478968 349.911775,745.200194 L391.686931,721.185308",
    id: "Stroke-3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150,426 L405,573",
    id: "Stroke-5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88,488 L346,637",
    id: "Stroke-7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M512,59 L270.054617,198.994278 C262.363364,203.413086 256.163713,210.024967 252.25346,217.986543 L153.901401,418.213818 C151.515434,423.067677 148.267785,427.446396 144.314448,431.137646 L96.5059668,475.763754 C92.2956114,479.695544 88.8667123,484.386074 86.399034,489.590349 C83.5034861,495.701847 82,502.380544 82,509.143875 L82,579.157347 C82,587.1115 86.2445255,594.461333 93.136494,598.442121 L344.227589,744",
    id: "Stroke-9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262,208 L517,355",
    id: "Stroke-11"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M526.62804,698.316505 C505.342799,732.566283 469.89955,748.995776 447.459825,735.013545 C425.021585,721.0328 424.08672,681.933075 445.37196,647.683297 C466.657201,613.435005 502.103418,597.004027 524.540175,610.986257 C546.978415,624.968488 547.91328,664.068213 526.62804,698.316505 Z",
    id: "Stroke-13"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M577,614 L771.599874,501.496948",
    id: "Stroke-15"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M641.775326,439.128379 L546.701236,494.45188 C539.498473,498.621783 530.428162,497.599427 524.327803,491.930266 C518.228929,486.259614 516.523324,477.264068 519.277846,470.14483 L547.897239,410.350382 C551.702164,402.404019 557.801038,395.789997 565.401973,391.36674 L679,325",
    id: "Stroke-19"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.39f663152ebd0aac12389ed6253e3d1a.svg";
export { ForwardRef as ReactComponent };